export default __webpack_public_path__ + "static/media/ALTEKIP_LOGO2020_QUADRI.b9bb4397.png";